module.exports = __webpack_public_path__ + "static/media/bold.3de47be3.svg";